/**
 * アプリのバージョン。
 * Service Worker の事前キャッシュを更新させたいときは、ここを上げてビルドし直す。
 * CSP などのHTTPヘッダーはキャッシュされたレスポンスごと保持されるため、
 * ヘッダーだけを変えても既存の端末には届かない。
 */
export const APP_VERSION = '1.4.1';
